import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/store/Reveal";
import { Marquee } from "@/components/store/Marquee";

const PORTRAIT = "/api/static/brand/about-founder.png";
const HERO = "/api/static/brand/founder-hero.png";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="pt-28 md:pt-36 pb-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <Reveal>
              <p className="overline text-terracotta mb-4">Our story</p>
              <h1 className="font-serif text-5xl md:text-7xl text-espresso tracking-tight leading-[0.95]">
                Skincare, <span className="italic text-terracotta">the safe way.</span>
              </h1>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-bark text-lg leading-relaxed mt-8 max-w-xl">
                17/11 BeautyBarn was founded by Eloho Akeni in Port Harcourt with one mission — to help people achieve
                healthy, glowing skin through safe products and honest education. What started as sharing skincare tips
                online has grown into a community of over 100,000 people learning to care for their skin the right way.
              </p>
            </Reveal>
          </div>
          <div className="md:col-span-5">
            <Reveal delay={0.1}>
              <div className="overflow-hidden rounded-[2rem]">
                <img src={PORTRAIT} alt="Founder" className="w-full aspect-[3/4] object-cover" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <Marquee items={["Founded in Port Harcourt", "Educate First", "Safe Formulas", "100K+ Community"]} />

      <section className="bg-sand py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-3 gap-10">
          {[
            { t: "Why safe skincare matters", d: "The wrong products can damage your skin barrier and cause lasting harm. We formulate gentle, effective products you can trust." },
            { t: "Education first", d: "We teach proper routines and product use so every customer sees real, lasting results — not quick fixes." },
            { t: "Built on community", d: "From TikTok to your bathroom shelf, we grow together — sharing wins, answering questions, glowing as one." },
          ].map((b, i) => (
            <Reveal key={b.t} delay={i * 0.1}>
              <div className="border-t border-sandline pt-6">
                <h3 className="font-serif text-2xl text-espresso mb-3">{b.t}</h3>
                <p className="text-bark leading-relaxed">{b.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative py-24 md:py-36 overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-espresso/70" />
        <div className="relative z-10 max-w-3xl mx-auto px-5 text-center">
          <Reveal>
            <h2 className="font-serif text-4xl md:text-6xl text-bone tracking-tight mb-8">
              Ready to start your glow journey?
            </h2>
            <Link
              to="/shop"
              className="inline-flex items-center gap-2 bg-terracotta text-bone px-8 py-4 rounded-full font-medium hover:bg-bone hover:text-espresso transition-colors"
              data-testid="about-shop-button"
            >
              Shop the collection <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
